import { render, staticRenderFns } from "./ProductsRecommendedList.vue?vue&type=template&id=3e35670a&scoped=true&"
import script from "./ProductsRecommendedList.vue?vue&type=script&lang=js&"
export * from "./ProductsRecommendedList.vue?vue&type=script&lang=js&"
import style0 from "./ProductsRecommendedList.vue?vue&type=style&index=0&id=3e35670a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e35670a",
  null
  
)

export default component.exports